import dateFormat from 'dateformat';
import DealerMapper from '../../../../../utils/dealer-mapper.js';

export default class TestDrivesSubview {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.test-drives');
        this.dealerUrl = this.parent.dealerUrl;
        this.card = this.el.querySelector('.card');
        this.testDrivesTemplate = _.template(parent.el.querySelector('#test-drives').innerHTML.replaceAll('\\', ''));
        this.noTestDrivesTemplate = _.template(parent.el.querySelector('#no-test-drives').innerHTML.replaceAll('\\', ''));
    }

    async populate() {
        const testDrives = await window.HONDA.MyAccount2.client.getTestDrives();
        const data = testDrives?.length > 0 ? await this.map(testDrives) : null;
        this.card.innerHTML = data ? this.testDrivesTemplate({ data, dateFormat }) : this.noTestDrivesTemplate();
        this.parent.update();
    }

    async map(testDrives) {
        let requests = [];
        testDrives
            .sort((t1, t2) => new Date(t1.bookingDateTime) - new Date(t2.bookingDateTime))
            .forEach((t) => {
                const request = window.HONDA.MyAccount2.client.getDealerDetails(this.dealerUrl, t.dealerCode);
                request.then((result) => t.dealer = DealerMapper.map(result));
                requests.push(request);
            });
        await Promise.all(requests);
        return testDrives;
    }
}